export default __webpack_public_path__ + "medium_low_coverage_ses_bc.png";